import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";
import { useGetJobCardByReferenceQuery } from "../api/apiSlice";

// QE's photo numbers (the keys of photo_vet_states) for each job-card photo field.
// The clamp-meter photos aren't vetted (N4), so they have none.
const QE_PHOTO_NUMBER = {
  install_photo_before: "1",
  before_photo_on: "2",
  before_photo_off: "3",
  after_photo_on: "4",
  after_photo_off: "5",
  install_photo_after: "6",
};

function vetStatesOf(card) {
  const raw = card?.photo_vet_states;
  if (typeof raw === "string") {
    try { return JSON.parse(raw) || {}; } catch { return {}; }
  }
  return raw || {};
}

// On a redo, a photo step keeps the photos already on the job that QE didn't decline and
// asks only for the declined ones. Every slot used to start empty, so a redo made the
// installer retake every photo on the step, approved ones included (N6).
//
// Kept slots are { kept: true, previewUrl } with no file: they count as captured and the
// save doesn't re-send them. Photos restored from this browser win over kept ones.
export default function useRedoPhotos(job_card_reference_id, photoDefs, setPhotos) {
  const { data: card } = useGetJobCardByReferenceQuery(job_card_reference_id, {
    skip: !job_card_reference_id,
  });
  const isRedo = card?.qe_job_state === "Declined";
  const vetStates = vetStatesOf(card);
  const isDeclined = (name) => isRedo && vetStates[QE_PHOTO_NUMBER[name]] === "declined";

  useEffect(() => {
    if (!isRedo) return;
    setPhotos((prev) =>
      prev.map((slot, i) => {
        if (slot) return slot;
        const { name } = photoDefs[i];
        if (isDeclined(name) || !card[name]) return null;
        return { kept: true, previewUrl: card[name] };
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRedo, card?.id]);

  // The line under a tile on a redo: what QE said about that photo.
  const slotNote = (i, photo) => {
    if (!isRedo) return null;
    if (photo?.kept) {
      return <Typography sx={{ fontSize: "0.6rem", color: "#4ade80", textAlign: "center", mt: "2px" }}>Approved by QE</Typography>;
    }
    if (!photo && isDeclined(photoDefs[i].name)) {
      return <Typography sx={{ fontSize: "0.6rem", color: "#f87171", textAlign: "center", mt: "2px" }}>Declined by QE — retake</Typography>;
    }
    return null;
  };

  return { slotNote };
}
